import { Pipe, PipeTransform } from '@angular/core';
import { getLastSignedAgreements } from 'ag-common-svc/lib/utils/last-signing-versions-by-agreement-type.util';
import { PolicySigners } from '@ag-common-lib/lib/models/utils/policy-signers.model';

@Pipe({
  name: 'lastSignedUserAgreements',
})
export class LastSignedUserAgreementsPipe implements PipeTransform {
  transform(agreements: PolicySigners[]): PolicySigners[] {
    return getLastSignedAgreements(agreements);
  }
}
